(function () {
    'use strict';

    angular.module('app').controller('LoadRatesCttController', LoadRatesCttController);

    LoadRatesCttController.$inject = [
        'CarrierLoadRatesTableService',
        'Carrier',
        '$routeParams',
        '$q',
        'toastr',
        '$uibModal',
        '$location'
    ];

    function LoadRatesCttController(
        CarrierLoadRatesTableService,
        Carrier,
        $routeParams,
        $q,
        toastr,
        $uibModal,
        $location
    ) {

        let vm = this;
        vm.id = $routeParams.id === 'new' ? false : $routeParams.id || false;
        vm.getCarrierProfiles = getCarrierProfiles;
        vm.getServiceProfile = getServiceProfile;
        vm.previewRateCard = previewRateCard;
        vm.save = save;
        vm.showCrateConfigModal = showCrateConfigModal;
        vm.showCrateArtWorkConfigModal = showCrateArtWorkConfigModal;
        vm.form = {
            carrierAccountCode: 'N/A',
            dateCreated: 'N/A',
            dateUpdated: 'N/A',
        };
        init();
        function getCarrierProfiles(refreshFilter, select) {
            if (select && !select.open)
                return;
            const defer = $q.defer();
            Carrier.getExternalCarrierProfiles((data) => {
                vm.carrierProfiles = data.content;
                defer.resolve(vm.carrierProfiles);
            }, (error) => {
                defer.reject(error);
            }, angular.extend({ size: 10 }, refreshFilter));

            return defer.promise;
        }

        function getServiceProfile(refreshFilter, select) {
            if (select && !select.open) { return; }
            const defer = $q.defer();

            Carrier.getServiceProfile(vm.id, (data) => {
                if (data.detailHidden) {
                    toastr.error('Service profile details don\'t exist');
                    $location.path('/carriers/service-profiles');
                    return false;
                }
                defer.resolve(data);
            }, (error) => {
                toastr.error('Service profile details don\'t exist', error.message);
                $location.path('/carriers/service-profiles');
                return false;
            }, angular.extend({ size: 10 }, refreshFilter));

            return defer.promise;
        }

        function previewRateCard() {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'r-c-p-modal',
                templateUrl: '/templates/pages/carriers/RateCardPrevModal.html',
                controller: 'RateCardPrevModalController',
                controllerAs: 'vm',
                size: 'lg',
                appendTo: $('body'),
                resolve: {
                    selected: function () {
                        return vm.form.flat_rate;
                    },
                    serviceRate: function () {
                        return vm.form;
                    }
                }
            });

            modalInstance.result.then(function (data) {
            }, function () {
            });
        }

        function showCrateConfigModal() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'r-c-p-modal',
                templateUrl: '/templates/pages/carriers/crate-config-modal.html',
                controller: 'PlywoodConfigModalController',
                controllerAs: 'vm',
                size: 'lg',
                appendTo: $('body'),
                resolve: {
                    selected: function () {
                        return vm.form.flat_rate;
                    },
                    serviceRate: function () {
                        return vm.form;
                    }
                }
            });
        }

        function showCrateArtWorkConfigModal() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'r-c-p-modal',
                templateUrl: '/templates/pages/carriers/artwork-config-modal.html',
                controller: 'CrateConfigModalController',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body'),
                resolve: {
                    selected: function () {
                        return vm.form.flat_rate;
                    },
                    serviceRate: function () {
                        return vm.form;
                    }
                }
            });
        }

        function save(value) {  
            vm.serviceProfileRaw.chargeDeadWeight = !value;
            Carrier.updateServiceProfile(vm.serviceProfileRaw.id, data => {
                toastr.success('Updated successfully');
            }, error => {
                toastr.error(error.message, "Error");
            }, cleanPayload(vm.serviceProfileRaw));
        }

        function cleanPayload(profile) {
            const payload = {
                chargeDeadWeight: profile.chargeDeadWeight,
                cubicConversionFactor: profile.cubicConversionFactor,
                carrierAccountCode: profile.carrierAccountCode ? profile.carrierAccountCode : null,
                carrierProfileId: profile.carrierProfile.id,
                name: profile.name ? profile.name : null,
                serviceName: profile.serviceName || null,
                settings: profile.settings,
                serviceId: profile.serviceId ? profile.serviceId : null,
                active: !!profile.active,
                insuranceAmount: profile.insuranceAmount,
                displayName: profile.displayName,
                shopifyQuoteOverride:profile.shopifyQuoteOverride,
                fuelLevy: {
                    enabled: angular.getObjVal(profile, 'fuelLevy.enabled'),
                    id: angular.getObjVal(profile, 'fuelLevy.details.id') ? angular.getObjVal(profile, 'fuelLevy.details.id') : null
                },
                networkEffectEnabled: profile.networkEffectEnabled,
                networkEffects: profile.networkEffects,
                currency: profile.currency,
                accountingSetting: {
                    autoReconcile: angular.getObjVal(profile, 'accountingSetting.autoReconcile') ? profile.accountingSetting.autoReconcile : false
                }
            };
            return payload;
        }

        function init() {
            if (vm.id) {
                vm.isViewMode = true;
            }
            
            $q.all({ serviceProfile: getServiceProfile() }).then((allRes) => {
                if (vm.id) {
                    if (!angular.getObjVal(allRes, 'serviceProfile.owned')) {
                        $location.path('/');
                        return false;
                    }

                    vm.serviceProfileRaw = angular.copy(allRes.serviceProfile);

                    if (angular.getObjVal(allRes, 'serviceProfile.service.rateCategories')) {
                        angular.forEach(allRes.serviceProfile.service.rateCategories, rateType => {
                            rateType.table = new CarrierLoadRatesTableService(angular.copy(angular.extend(vm.form,
                                allRes.serviceProfile)), angular.copy({ rateType }));
                            rateType.table.onUpdateRecord(() => {
                                angular.forEach(allRes.serviceProfile.service.rateCategories, rateType => {
                                    rateType.table.refresh();
                                });
                            });
                        });
                    }
                }
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/LoadRatesCttController.js